<template>
  <div class="succes-register">
    <v-container>
      <p>
        {{ $t("Ваше сообщение успешно отправлено!") }}
      </p>
      <p>
        <a href="#" @click.prevent="notification">{{ $t("Отправить еще раз") }}</a> {{ $t("или") }} <a href="#" @click.prevent="MyOrganization">{{ $t("перейти в Рабочий кабинет") }}</a>
      </p>
    </v-container>
  </div>
</template>

<script>
export default {
  created () {
    this.scrollToTop()
  },
  methods: {
    async notification () {
      this.$router.push('notification')
    },
    async MyOrganization () {
      this.$router.push('my-organization')
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.succes-register {
  font-style: italic;
  font-weight: 300;
  font-size: 22px;
  color: #000;
  padding: 80px 0px 40px;
  text-align: center;
  line-height: 120%;
  border-top: 1px solid #dde8f0;

  a {
    display: inline-block;
    border-bottom: 1px solid;
    line-height: 1;
  }

  a:hover {
    border-color: transparent;
  }
}
</style>
